// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import axios from 'axios'
import router from './router'
import store from './store'
import './icon/iconfont.js'
import IconSvg from '@/components/icon-svg'
//引入swiper
import VueAwesomeSwiper from "vue-awesome-swiper"

// 引入swiper样式
import "swiper/dist/css/swiper.css";
//挂载swiper
Vue.use(VueAwesomeSwiper);
//全局注册icon-svg
Vue.component('icon-svg', IconSvg)

Vue.config.productionTip = false





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js